import React, { useState } from 'react'
import { useMutation } from '@apollo/client';
import { RESEND_EMAIL, VERIFY_EMAIL } from '../..//apollo/gql/query/user.query';
import { toast } from 'react-toastify';
import useCompanyId from '../../hooks/useCompanyId';

const EmailConfirmation = () => {

  const [resendVerificationEmail] = useMutation(RESEND_EMAIL)
  const [loading, setLoading] = useState(false);
  const userDataJSON = localStorage.getItem('userData');
  const userData = userDataJSON ? JSON.parse(userDataJSON) : null;
  const companyId = useCompanyId()

  const handleResendEmail = () => {
    if (loading) return;
    setLoading(true);
    const input = {
      email: userData?.email,
      domain: window.location.origin
    }

    resendVerificationEmail({ variables: { email: input.email, companyId: companyId, domain: input.domain } })
      .then((response) => {
        if (response.data.resendVerificationEmail) {
          toast.success('Verification link sent successfully')
        } else {
          toast.error('Something went wrong')
        }
      }).catch((error) => {
        toast.error(error.message)
      }).finally(() => {
        setLoading(false);
      })
  }

  return (

    <div className="flex h-full min-h-screen w-screen flex-col justify-center bg-light md:h-auto md:min-h-0 md:max-w-[530px]">
      <div className="items-center p-10">
        <div className='flex justify-center'>
          <img
            src={'/mail.svg'} // Default image, you can make this dynamic
            className="w-[45px] h-[45px]"
            alt={`mail selection`}
          />
          {/* <MailOutlined
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-[clamp(36px,6vw,72px)]"/> */}
        </div>
        <div className='text-center mb-3 mt-9'>
          <h3 className='md:text-xl text-lg mb-2 font-medium'>Email Confirmation</h3>
          <p className='text-muted'>We have sent confirmation email to <span className='text-[#6C80FE]'>{userData?.email}</span> to
            verify your email address.
          </p>
          <p className='text-muted'>Please check your inbox and click the verification link to complete your registration.
          </p>
        </div>
        <hr />
        <p className='mt-3 text-center text-[15px] font-bold'>Don't receive the email? </p>
        <p className="mt-3 text-center text-[15px] text-muted">
          <span
            className={`text-[#6C80FE] cursor-pointer ${loading ? "opacity-50 pointer-events-none" : ""}`}
            onClick={handleResendEmail}
          >
            {loading ? "Sending..." : <u>Resend confirmation mail</u>}
          </span>
        </p>
      </div>
    </div>
  )
}

export default EmailConfirmation